import httpManager from "@/app/shared/utils/httpManager";
/**
 * Validate Agent connection and status before transferring
 *
 * @param {Object} body - { user, tickets, is_call }
 */
export async function validateAgentTransfer(body) {
    const response = await httpManager.post(`/tickets/transfer-validate-agent/`, body);
    return response.data;
}
